import { render, staticRenderFns } from "./_settlementList.vue?vue&type=template&id=3a6af784&lang=pug&"
import script from "./_settlementList.vue?vue&type=script&lang=js&"
export * from "./_settlementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports